import { useMotionValue } from 'motion/react';
import { useEffect } from 'react';
export const useDistanceToTopOfPageMotionValue = (ref) => {
    const distanceToTopOfPage = useMotionValue(0);
    const setDistance = (ref) => {
        const topToViewport = ref.current?.getBoundingClientRect()?.top ?? 0;
        const topToPage = topToViewport + window.scrollY;
        distanceToTopOfPage.set(topToPage);
    };
    useEffect(() => {
        // Only calculate once when component mounts or ref changes
        setDistance(ref);
        // No need for interval since this value shouldn't change
        // If you need to recalculate on scroll or resize:
        const handlePositionChange = () => setDistance(ref);
        window.addEventListener('resize', handlePositionChange);
        return () => {
            window.removeEventListener('resize', handlePositionChange);
        };
    }, [ref]);
    return distanceToTopOfPage;
};
